<template>
    <el-dialog
      :visible.sync="showCreateMouldDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :width="'500px'"
      :before-close="doCancel"
      custom-class="mould-dialog"
    >
        <div v-if="type === methodsType.methods" class="btn-group">
            <el-button @click="uploadImg" class="operate-btn">上传图片制作印模</el-button>
            <el-button @click="changeType(methodsType.image)" class="operate-btn">从存量印章获取印模图片</el-button>
        </div>

        <div v-if="type === methodsType.image" class="img-content">
          <div v-for="imgItem in imgList"
              :key="imgItem.pic_data"
              :class="{'img-item': true, 'is-select': currentImg === imgItem.pic_data}"
              >
              <img
                  v-lazy="{
                      src: `${imgItem.pic_data}`,
                      loading: placeholderImage,
                  }"
                  @click="chooseImg(imgItem.pic_data)"
                  alt="" />
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button type="default" @click="uploadImg" v-if="type === methodsType.image">上传图片制作</el-button>
            <el-button type="primary" @click="doConfirm">确定</el-button>
        </span>

  </el-dialog>
</template>

<script>
const titleType = {
    methods: '请选择章模制作方式',
    image: '请选择章模',
};
export default {
    props: {
        showCreateMouldDialog: Boolean,
        imgList: {
            type: Array,
            default: () => {
                return [];
            }
        },
    },
    data() {
        return {
            type: 'methods',
            currentImg: '',
            placeholderImage: require('../../assets/images/common/placeholder.png'),
            methodsType: {
                methods: 'methods',
                image: 'image'
            }
        };
    },
    computed: {
        title() {
            return titleType[this.type];
        }
    },
    created() {
        const img = this.imgList?.[0].pic_data;
        this.chooseImg(img);
    },
    methods: {
        chooseImg(img) {
            this.currentImg = img;
        },
        doConfirm() {
            this.doCancel();
            this.$emit('handleImgByCreat', this.currentImg);
        },
        uploadImg() {
            this.$emit('upload');
            this.doCancel();
        },
        doCancel() {
            this.$emit('update:showCreateMouldDialog', false);
        },
        changeType(type) {
            this.type = type;
        }
    },
};
</script>

<style lang="less" scoped>
.img-content {
    display: flex;
    justify-content: space-between;
    height: 300px;
    flex-wrap: wrap;
    overflow-y: scroll;
}
.btn-group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
}
.operate-btn {
    padding: 25px;
}
.img-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 49%;
    padding: 10px;
}
.is-select {
    border: 1px solid @primary;
}
</style>
<style lang="less">
.mould-dialog {
    .el-dialog__body {
      padding-top: 30px;
    }
}
</style>
